// computerScienceData.js

const computerScienceData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "34",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34_39", code: "MATH 34 / MATH 39", title: "Calculus II or Honors Calculus I-II", credit: 4 },
        { id: "MATH42_44", code: "MATH 42 / MATH 44", title: "Calculus III or Honors Calculus III", credit: 4 },
        { id: "CSMATH61", code: "CS/MATH 61", title: "Discrete Math or MATH 65 Foundations of higher mathematics", credit: 3 },
        { id: "MATH70_72", code: "MATH 70 / MATH 72", title: "Linear Algebra or Abstract Lin. Alg.", credit: 3 },
        { id: "BCP_Elective1", code: "BIO-CHEM-PHY Elective (a)", title: "", credit: 5 },
        { id: "BCP_Elective2", code: "BIO-CHEM-PHY Elective (b)", title: "", credit: 5 },
        { id: "MNS_Elective", code: "MNS Elective (b)", title: "", credit: "≥3" },
        { id: "ProbStat_Elective", code: "Prob & Stat Elective (c)", title: "", credit: "≥3" },
      ],
    },
    {
      section: "HASS",
      subtotal: "24",
      courses: [
        { id: "ENG1", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        { id: "HASS_Humanities", code: "Humanities Elective (d)", title: "", credit: "≥3" },
        { id: "HASS_Social", code: "Social Science Elective (e)", title: "", credit: "≥3" },
        { id: "HASS_Humanities2", code: "Humanities Elective (d)", title: "", credit: "≥3" },
        { id: "HASS_Social2", code: "Social Science Elective (e)", title: "", credit: "≥3" },
        { id: "HASS_Humanities3", code: "Humanities Elective (d)", title: "", credit: "≥3" },
        { id: "HASS_Ethics", code: "Ethics & Social Context Elec. (f)", title: "", credit: "3-4" },
        { id: "EM52", code: "Technical Writing (EM52)", title: "Technical Writing", credit: 3 },
      ],
    },
    {
      section: "Engineering",
      subtotal: "6",
      courses: [
        { id: "EN1", code: "EN 1", title: "Applications in Eng.", credit: 3 },
        { id: "ES2", code: "ES 2", title: "Intro. Computing in Eng. or ENG-CS Elective (h)", credit: "3" },
      ],
    },
    {
      section: "Computer Science Core",
      subtotal: "49",
      courses: [
        { id: "CS11", code: "CS 11", title: "Intro. Comp. Sci.", credit: 4 },
        { id: "CS15", code: "CS 15", title: "Data Structures", credit: 4 },
        { id: "CS40", code: "CS 40", title: "Machine Structure & Assembly-Language Prog.", credit: 5 },
        { id: "CS105_CS80", code: "CS 105 / CS 80", title: "Programming Languages", credit: "3-5" },
        { id: "CS160", code: "CS 160", title: "Algorithms", credit: 4 },
        { id: "CS170", code: "CS 170", title: "Comp. Theory", credit: 3 },
        { id: "Systems1", code: "Systems Elective (i)", title: "", credit: "≥3" },
        { id: "Systems2", code: "Systems Elective (i)", title: "", credit: "≥3" },
        { id: "CS_Elective_j1", code: "CS Elective (j)", title: "", credit: "≥3" },
        { id: "CS_Elective_j2", code: "CS Elective (j)", title: "", credit: "≥3" },
        { id: "CS_Elective_k", code: "CS Elective (k)", title: "", credit: "≥3" },
        { id: "CS_Elective_l", code: "CS Elective (l)", title: "", credit: "≥3" },
        { id: "CS_SocialCont", code: "CS Social Cont. Elective (m)", title: "", credit: "≥2" },
        { id: "CS97", code: "CS 97", title: "Sr. Capstone Proj. I", credit: 3 },
        { id: "CS98", code: "CS 98", title: "Sr. Capstone Proj. II", credit: 3 },
      ],
    },
    {
      section: "Breadth Electives",
      subtotal: "6",
      courses: [
        { id: "Breadth", code: "Breadth Electives", title: "≥6 SHU of Breadth Electives are required for the degree. List courses below (see note n).", credit: "" },
        { id: "Breadth2", code: "Breadth Electives", title: "≥6 SHU of Breadth Electives are required for the degree. List courses below (see note n).", credit: "" },
      ],
    },
  ];
  
  export default computerScienceData;
  